import { render } from "./PartnerYamaha.vue?vue&type=template&id=1b123d3c"
import script from "./PartnerYamaha.vue?vue&type=script&lang=js"
export * from "./PartnerYamaha.vue?vue&type=script&lang=js"

import exportComponent from "/Users/leviathan/sites/webbank/webbank-static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__